import { idToStrongId } from "@oysterhr/common"
import { generatePath } from "react-router-dom"
import { companyBasePath } from "../../utils/baseRoutes"

// EXPENSES
const _expensesPath = (companyId: string, path?: string) => {
  return companyBasePath({ companyId, path: generatePath("expenses/*", { "*": path || "" }) })
}

export const companyExpensesPath = (companyId: string) => {
  return _expensesPath(companyId)
}

export const companyNewExpensePath = (companyId: string) => {
  return _expensesPath(companyId, "new")
}

// SUBSCRIPTIONS
export const companySubscriptionsPath = (companyId: string) => {
  return companyBasePath({ companyId, path: "subscriptions" })
}

// PAYMENT INFORMATION
const _paymentMethodsPath = (companyId: string, path?: string) => {
  return companyBasePath({
    companyId,
    path: generatePath("payment-methods/*", { "*": path || "" }),
  })
}

export const companyPaymentMethodsPath = (companyId: string) => {
  return _paymentMethodsPath(companyId)
}

export const companySepaFlowPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "sepa-bank-details")
}

export const companySepaMandatePath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "sepa/mandate")
}

export const companyBacsFlowPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "bacs-flow")
}

export const companyPadFlowPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "pad-flow")
}

export const companyPaymentMethodAuthorizePath = (companyId: string, paymentMethodId: string) => {
  return _paymentMethodsPath(companyId, `${idToStrongId(paymentMethodId)}/authorize`)
}

export const companyAchFlowPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "ach-landing-screen")
}

export const companyPaymentMethodsAchBankDetailsPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "ach-bank-details")
}

// NOTE: Below are new payment flow paths
export const companySepaPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "sepa")
}

export const companySepaMethodTypePath = (companyId: string, methodType: string) => {
  return _paymentMethodsPath(companyId, `sepa/${methodType}`)
}

export const companyAchPath = (companyId: string) => {
  return _paymentMethodsPath(companyId, "ach")
}

export const companyAchMethodTypePath = (companyId: string, methodType: string) => {
  return _paymentMethodsPath(companyId, `ach/${methodType}`)
}
